<template>
  <div>
    <NBar title="帐号与安全"/>
    <nut-cell :show-icon="true" title="更改登录密码" @click-cell="openPwd()">
    </nut-cell>
    <nut-button style="margin: 15px 15px 60px 15px;border-radius: 5px;width:92%;" @click="logout">退出帐号</nut-button>
  </div>
</template>

<script>
export default {
  name: 'Security',
  data () {
    return {}
  },
  methods: {
    openPwd () {
      this.$router.push('/device/Password')
    },
    logout () {
      localStorage.removeItem('token')
      this.$router.push('/device/login')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/Security.vue